/**
 * Used on the login page - newspaper.com/section/login?map=nextbee
 */
__gh__webApp.consumerMarketing.nextbee 	= {

	/**
	 * Paywall login success callback
	 */
	"loginSuccessCallback": function(){
		__gh__webApp.paywall.refreshExperienceCallbacks.push({"callback":'__gh__webApp.consumerMarketing.nextbee.redirect'});
		__gh__webApp.paywall.refreshExperience();
	},
	
	/**
	 * Redirect
	 * Passes the user credentials to dispatch webservice and generates an encrypted url the user is redirected to
	 */
	"redirect": function(){
		var vxStorageObj 	= JSON.parse(__gh__webApp.localStorage.getItem("_vxData")),
			firstName 		= vxStorageObj.firstName,
			lastName		= vxStorageObj.lastName,
			email			= vxStorageObj.email,
			subStatus 		= (vxStorageObj.access) ? 1 : 0,
			link 			= "http://dev.sso.dispatch.com/controller/nextbee.php?email="+email+"&firstName="+firstName+"&lastName="+lastName+"&subStatus="+subStatus;

		$.post(link, function( data ) {
			//Redirect
			window.location.href = data.data;
		});
	}
 };
